// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Go6R3","content":"styles_content__1YtUX"};